import React from "react";

const SwapHeaderMenu = ({
  name,
  onClick,
  activeMenu,
}: {
  name: String;
  onClick: React.MouseEventHandler<HTMLDivElement>;
  activeMenu: String;
}) => {
  return (
    <div
      onClick={onClick}
      className={`swap-header-menu-container ${
        name === activeMenu ? "swap-header-menu-container__active" : ""
      }`}
    >
      <div className="swap-header-menu-button">{name}</div>
    </div>
  );
};

export default SwapHeaderMenu;
